const validateEmail = (email) => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}

const getEmailName = (email) => {
  // Get the name part of email if any
  if (email.match(/^.+(?=@)/)) {
    return email.match(/^.+(?=@)/)[0] // get the name part of the email
  }
  return email
}

export default {
  validateEmail,
  getEmailName,
}
